import { useQuery, UseQueryOptions } from 'react-query';
import { SocialMediaLink } from '@services/types/api';
import QueryKeys from '@constants/query-keys';
import { ApiClientEnterpriseLinksReview } from '@helpers/apiClients';

export const getLinksReview = async (): Promise<{ data: SocialMediaLink[] }> => {
  const response = await ApiClientEnterpriseLinksReview.get(`/social-media-links`);
  return response;
};

export const getLinksReviewQueryOptions = (): UseQueryOptions<{ data: SocialMediaLink[] }> => {
  return {
    queryKey: [QueryKeys.enterpriseLinksReview],
    queryFn: getLinksReview,
  };
};

type UseUsersOptions = {
  queryConfig?: UseQueryOptions<{ data: SocialMediaLink[] }>;
};

export const useLinksReview = ({ queryConfig }: UseUsersOptions = {}) => {
  return useQuery({
    ...getLinksReviewQueryOptions(),
    ...queryConfig,
  });
};
